import { BaseEntity } from 'src/app/tools/models/baseEntity';
import { PromoPartnerFamilyPartner } from './promo-partner-family-partner.entity';


export class PromoPartnerFamily extends BaseEntity {
  
  promoPartnerFamilyCode        : string;
  name                          : string;
  rank                          : number

  promoPartnerFamilyPartners  : PromoPartnerFamilyPartner[];

    constructor() {
      super()
    }
}
